import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { logout } from "../actions/authenActions";

const baseURL = process.env.REACT_APP_API_URL || "http://localhost:8000";

export const fetchTableOne = createAsyncThunk(
  "activityFrame/fetchTableOne",
  async ({ liverun, license_key }, { dispatch, rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${baseURL}/emis_pathology/api/blood_filings_count_by_date`,
        {
          liverun,
          license_key,
        },
      );
      return res.data || [];
    } catch (error) {
      if (error.response && error.response.status === 403) {
        dispatch(logout());
      }
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  },
);

export const fetchTableTwo = createAsyncThunk(
  "activityFrame/fetchTableTwo",
  async ({ date, liverun, license_key }, { dispatch, rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${baseURL}/emis_pathology/api/blood_filings_category_by_date`,
        {
          date,
          liverun,
          license_key,
        },
      );
      return res.data || [];
    } catch (error) {
      if (error.response && error.response.status === 403) {
        dispatch(logout());
      }
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  },
);

export const fetchTableThree = createAsyncThunk(
  "activityFrame/fetchTableThree",
  async ({ date, liverun, license_key }, { dispatch, rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${baseURL}/emis_pathology/api/blood_filings_data_by_date`,
        {
          date,
          liverun,
          license_key,
        },
      );
      return res.data || [];
    } catch (error) {
      if (error.response && error.response.status === 403) {
        dispatch(logout());
      }
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  },
);

const activityFrameSlice = createSlice({
  name: "activityFrame",
  initialState: {
    liverun: true,
    tableOne: [],
    tableTwo: [],
    tableThree: [],
    selectedDate: null,
    loadingOne: false,
    loadingTwo: false,
    loadingThree: false,
  },
  reducers: {
    toggleLiverun(state) {
      state.liverun = !state.liverun;
      state.tableTwo = [];
      state.tableThree = [];
      state.selectedDate = null;
    },
    setSelectedDate(state, action) {
      state.selectedDate = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTableOne.pending, (state) => {
        state.loadingOne = true;
      })
      .addCase(fetchTableOne.fulfilled, (state, action) => {
        state.tableOne = action.payload.map((rec, idx) => ({
          id: idx,
          date: rec[0],
          filed: rec[2],
          filed_abnormal: rec[3],
          not_filed_range: rec[4],
          not_filed_setup: rec[5],
          not_filed_already: rec[6],
        }));
        state.loadingOne = false;
      })
      .addCase(fetchTableTwo.pending, (state) => {
        state.loadingTwo = true;
      })
      .addCase(fetchTableTwo.fulfilled, (state, action) => {
        state.tableTwo = action.payload.map((rec, idx) => ({
          id: idx,
          category: rec[0],
          filed: rec[2],
          filed_abnormal: rec[3],
          not_filed_range: rec[4],
          not_filed_setup: rec[5],
          not_filed_already: rec[6],
        }));
        state.loadingTwo = false;
      })
      .addCase(fetchTableThree.pending, (state) => {
        state.loadingThree = true;
      })
      .addCase(fetchTableThree.fulfilled, (state, action) => {
        state.tableThree = action.payload.map((rec, idx) => ({
          id: idx,
          emis_id: rec[0],
          category: rec[1],
          status: rec[2],
          endtime: rec[3],
          notes: rec[4],
        }));
        state.loadingThree = false;
      });
  },
});

export const { toggleLiverun, setSelectedDate } = activityFrameSlice.actions;

export default activityFrameSlice.reducer;
